// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { hasCookieConsent } from "./hooks/useCookieConsent";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBIVCSmmkAB5Mim-2hIPSb_Dpap2WgFgo4",
  authDomain: "quotabus-noleggio.firebaseapp.com",
  projectId: "quotabus-noleggio",
  storageBucket: "quotabus-noleggio.firebasestorage.app",
  messagingSenderId: "286166788790",
  appId: "1:286166788790:web:e91a350ab992c48c641417",
  measurementId: "G-G5DJ29D89C",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export let analytics = null;
// Ensure analytics is enabled
function ensureAnalyticsEnabled() {
  if (analytics) return analytics;
  if (!hasCookieConsent("analytics")) return null;
  analytics = getAnalytics(app);
  return analytics;
}

export const FirebaseAnalytics = () => {
  const location = useLocation();
  const { i18n } = useTranslation();

  const logPageView = (a) => {
    const page_path = location.pathname + location.search;
    const busPartnerCode = process.env.REACT_APP_PARTNER_CODE;
    logEvent(a, "page_view", {
      page_path: "lp-" + busPartnerCode + page_path,
      bus_partner: busPartnerCode,
      user_lang: i18n.language,
    });
  };

  useEffect(() => {
    const a = ensureAnalyticsEnabled();
    if (a) {
      logPageView(a);
    }
  }, [location, i18n.language]);

  // Listen for cookie consent updates
  useEffect(() => {
    const onConsentUpdate = () => {
      const a = ensureAnalyticsEnabled();
      // If user just enabled analytics, log the current page immediately
      if (a) logPageView(a);
    };
    window.addEventListener("cookieConsentUpdated", onConsentUpdate);
    return () => window.removeEventListener("cookieConsentUpdated", onConsentUpdate);
  }, []);

  return null;
};
